var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-4"},[_c('page-header',{attrs:{"title":_vm.$t('common_345')}}),_c('page-body',[_c('me-process')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }